import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import Footer from "../../components/footer";
import { useNavigate, useParams } from "react-router-dom";
import { getProfile } from "../../services/api";

function SettingsEdit() {
  const { id: uuid } = useParams();
  const [isLightTheme, setIsLightTheme] = useState(true);
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const response = await getProfile();
    console.log(response, "profile");
    setProfile(response);
  };
  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed]">
      <div
        className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto"
        style={{
          backgroundImage: "url(/assets/pngImages/kategoriBG.png)",
          backgroundSize: "cover",
          backgroundPosition: "center 130px",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex flex-col items-center w-full min-h-full">
          <div className="flex gap-2 w-full justify-between mt-2">
            <button type="button" onClick={() => navigate("/" + uuid + "/settings")}>
              <IoIosArrowBack className=" ml-2 text-2xl" />
            </button>
            <div className="text-left mt-8   leading-none w-full">
              <h1 className="text-[20px] font-poppins text-[#3F414E] mb-2 font-bold text-left">
           {profile?.profile?.details?.first_name} {profile?.profile?.details?.last_name}
              </h1>
              <h2 className="text-[15px] font-poppins text-[#3F414E] mb-12 text-left">
                Ayarlar
              </h2>
            </div>
          </div>

          <div className="flex flex-col items-start w-full gap-3 pt-0  p-4  ">
            {/* <div className="bg-[#F0F3F6] flex flex-row items-center justify-between w-full p-3 rounded-lg">
              <div className="flex flex-row items-center">
                <img
                  src="/assets/profilePageImages/temaButtonProfile.png"
                  alt=""
                  className=" "
                />
                <h1 className="text-[14px] font-poppins text-[#31507F] ml-3">
                  Aydınlık Tema
                </h1>
              </div>

              <div
                className="relative inline-flex items-center cursor-pointer"
                onClick={() => setIsLightTheme(!isLightTheme)}
              >
                <div
                  className={`relative w-11 h-6 rounded-full transition-colors duration-300 ${
                    isLightTheme ? "bg-[#31507F]" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out flex items-center justify-center ${
                      isLightTheme ? "translate-x-5" : "translate-x-0.5"
                    }`}
                  >
                    {isLightTheme && (
                      <svg
                        className="w-3 h-3 text-blue-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            </div> */}
            <button className="bg-[#F0F3F6] flex flex-row items-center w-full p-3   rounded-lg">
              <img
                src="/assets/profilePageImages/languageButtonProfile.png"
                alt=""
                className=" "
              />
              <h1 className="text-[14px] font-poppins text-[#31507F] ml-3">
                Dil Değişikliği
              </h1>
            </button>
            <button className="bg-[#F0F3F6] flex flex-row items-center w-full p-3   rounded-lg">
              <img
                src="/assets/profilePageImages/lockButtonProfile.png"
                alt=""
                className="   "
              />
              <h1 className="text-[14px] font-poppins text-[#31507F] ml-3">
                Hesabı Askıya Al
              </h1>
            </button>

            <button className="bg-[#FFF4F4] flex flex-row items-center w-full p-3  rounded-lg">
              <img
                src="/assets/profilePageImages/deleteAccButtonProfile.png"
                alt=""
                className=" "
              />
              <h1 className="text-[14px] font-poppins text-[#FF5648] ml-3">
                Hesabımı Sil
              </h1>
            </button>
          </div>
        </div>
      </div>  
      <Footer uuid={uuid} />
    </div>
  );
}

export default SettingsEdit;
